<template>
  <div class="container-fluid px-4 mt-4">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div>
        <h5 class="fw-bold mb-1">주차장 관리</h5>
        <small class="text-muted">서버시간: {{ serverTime }}</small>
      </div>
      <button class="btn btn-primary btn-sm" @click="openAdd">+ 주차장 등록</button>
    </div>
    <!-- 요금제 관리 모달 -->
    <div v-if="feeModal" class="modal-backdrop-custom">
      <div class="modal-box" style="width:720px; max-width:95vw;" @click.stop>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="fw-bold mb-0">요금제 관리 - {{ feeArea?.AreaName }} (<code>{{ feeArea?.AreaCode }}</code>)</h6>
          <button class="btn-close" @click="feeModal = false"></button>
        </div>

        <div class="row">
          <div class="col-7">
            <div v-if="feeLoading" class="text-center text-muted py-4">불러오는 중...</div>
            <div v-else>
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>요금명</th>
                    <th class="text-end">가격(원)</th>
                    <th class="text-center">관리</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="fees.length === 0">
                    <td colspan="4" class="text-center text-muted py-3">등록된 요금제가 없습니다.</td>
                  </tr>
                  <tr v-for="f in fees" :key="f.FeeSeq">
                    <td class="text-muted small">{{ f.FeeSeq }}</td>
                    <td>{{ f.FeeName }}</td>
                    <td class="text-end">{{ f.Price.toLocaleString() }}</td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-outline-primary me-1" @click="openEditFee(f)">수정</button>
                      <button class="btn btn-sm btn-outline-danger" @click="confirmDeleteFee(f)">삭제</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-5">
            <div class="mb-2 d-flex justify-content-between align-items-center">
              <strong class="small">요금제 추가/수정</strong>
              <button class="btn btn-sm btn-outline-secondary" @click="openAddFee">새로작성</button>
            </div>
            <div class="mb-2">
              <label class="form-label form-label-sm">요금명 <span class="text-danger">*</span></label>
              <input v-model="feeForm.FeeName" type="text" class="form-control form-control-sm" maxlength="100" />
            </div>
            <div class="mb-3">
              <label class="form-label form-label-sm">가격(원) <span class="text-danger">*</span></label>
              <input v-model.number="feeForm.Price" type="number" class="form-control form-control-sm" min="0" />
            </div>
            <div v-if="feeFormError" class="alert alert-danger py-1 small">{{ feeFormError }}</div>
            <div class="d-flex gap-2 justify-content-end">
              <button class="btn btn-secondary btn-sm" @click="feeModal = false">닫기</button>
              <button class="btn btn-primary btn-sm" :disabled="feeSaving" @click="saveFee">{{ feeSaving ? '저장 중...' : '저장' }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 그룹 관리 모달 -->
    <div v-if="groupModal" class="modal-backdrop-custom">
      <div class="modal-box" style="width:720px; max-width:95vw;" @click.stop>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="fw-bold mb-0">그룹 관리 - {{ groupArea?.AreaName }} (<code>{{ groupArea?.AreaCode }}</code>)</h6>
          <button class="btn-close" @click="groupModal = false"></button>
        </div>

        <div class="row">
          <div class="col-7">
            <div v-if="groupLoading" class="text-center text-muted py-4">불러오는 중...</div>
            <div v-else>
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>그룹명</th>
                    <th class="text-end">할당수량</th>
                    <th class="text-center">관리</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="groups.length === 0">
                    <td colspan="4" class="text-center text-muted py-3">등록된 그룹이 없습니다.</td>
                  </tr>
                  <tr v-for="g in groups" :key="g.GroupSeq">
                    <td class="text-muted small">{{ g.GroupSeq }}</td>
                    <td>{{ g.GroupName }}</td>
                    <td class="text-end">{{ g.QuotaCount }}</td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-outline-primary me-1" @click="openEditGroup(g)">수정</button>
                      <button class="btn btn-sm btn-outline-danger" @click="confirmDeleteGroup(g)">삭제</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-5">
            <div class="mb-2 d-flex justify-content-between align-items-center">
              <strong class="small">그룹 추가/수정</strong>
              <button class="btn btn-sm btn-outline-secondary" @click="openAddGroup">새로작성</button>
            </div>
            <div class="mb-2">
              <label class="form-label form-label-sm">그룹명 <span class="text-danger">*</span></label>
              <input v-model="groupForm.GroupName" type="text" class="form-control form-control-sm" maxlength="100" />
            </div>
            <div class="mb-3">
              <label class="form-label form-label-sm">할당수량 <span class="text-danger">*</span></label>
              <input v-model.number="groupForm.QuotaCount" type="number" class="form-control form-control-sm" min="0" />
            </div>
            <div v-if="groupFormError" class="alert alert-danger py-1 small">{{ groupFormError }}</div>
            <div class="d-flex gap-2 justify-content-end">
              <button class="btn btn-secondary btn-sm" @click="groupModal = false">닫기</button>
              <button class="btn btn-primary btn-sm" :disabled="groupSaving" @click="saveGroup">{{ groupSaving ? '저장 중...' : '저장' }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loadError" class="alert alert-danger">{{ loadError }}</div>
    <div v-if="loading" class="text-center py-5 text-muted">불러오는 중...</div>

    <table v-else class="table table-hover align-middle">
      <thead class="table-dark">
        <tr>
          <th>#</th>
          <th>구역 코드</th>
          <th>API Key</th>
          <th>구역명</th>
          <th>MID</th>
          <th>Cancel Pwd</th>
          <th>은행명</th>
          <th>계좌번호</th>
          <th>접수기간</th>
          <th class="text-center">관리</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="areas.length === 0">
          <td colspan="9" class="text-center text-muted py-4">등록된 주차장이 없습니다.</td>
        </tr>
        <tr v-for="a in areas" :key="a.AreaSeq">
          <td class="text-muted small">{{ a.AreaSeq }}</td>
          <td><code>{{ a.AreaCode }}</code></td>
          <td style="max-width:220px; word-break:break-all;">
            <div v-if="a.ApiKey">{{ a.ApiKey }}</div>
            <div v-else class="text-muted">-</div>
            <div>
              <small v-if="a.ApiEnabled" class="badge bg-success mt-1">활성</small>
              <small v-else class="badge bg-secondary mt-1">비활성</small>
            </div>
          </td>
          <td>{{ a.AreaName }}</td>
          <td style="max-width:140px; word-break:break-all;">{{ a.MID || '-' }}</td>
          <td style="max-width:140px; word-break:break-all;">{{ a.CancelPwd || '-' }}</td>
          <td style="max-width:160px; word-break:break-all;">{{ a.BankName || '-' }}</td>
          <td style="max-width:180px; word-break:break-all;">{{ a.AccountNumber || '-' }}</td>
          <td style="max-width:200px; word-break:break-all;">
            <span v-if="a.AcceptStartDate || a.AcceptEndDate">
              {{ a.AcceptStartDate ? new Date(a.AcceptStartDate).toISOString().slice(0, 10) : '-' }} ~
              {{ a.AcceptEndDate ? new Date(a.AcceptEndDate).toISOString().slice(0, 10) : '-' }}
            </span>
            <span v-else class="text-muted">-</span>
          </td>
          <td class="text-center">
            <button class="btn btn-sm btn-outline-info me-1" @click="openApiKey(a)">API Key</button>
            <button class="btn btn-sm btn-outline-secondary me-1" @click="openFeeManage(a)">요금제 관리</button>
            <button class="btn btn-sm btn-outline-warning me-1" @click="openGroupManage(a)">그룹 관리</button>
            <button class="btn btn-sm btn-outline-success me-1" @click="openAreaDetail(a)">주차장 정보</button>
            <button class="btn btn-sm btn-outline-primary me-1" @click="openEdit(a)">수정</button>
            <button class="btn btn-sm btn-outline-danger" @click="confirmDelete(a)">삭제</button>
          </td>
        </tr>
      </tbody>
    </table>
    <ApiKeyModal v-if="apiModal" :area="apiArea" @close="onApiModalClose" />

    <!-- 등록/수정 모달 -->
    <div v-if="formModal" class="modal-backdrop-custom">
      <div class="modal-box" @click.stop>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="fw-bold mb-0">{{ isEdit ? '주차장 수정' : '주차장 등록' }}</h6>
          <button class="btn-close" @click="formModal = false"></button>
        </div>

        <div class="mb-2">
          <label class="form-label form-label-sm">구역 코드 <span class="text-danger">*</span></label>
          <input v-model="form.AreaCode" type="text" class="form-control form-control-sm" maxlength="20" placeholder="예: A-01" />
        </div>
        <div class="mb-2">
          <label class="form-label form-label-sm">구역명 <span class="text-danger">*</span></label>
          <input v-model="form.AreaName" type="text" class="form-control form-control-sm" maxlength="100" placeholder="예: A동 지하 1층" />
        </div>
        <div class="mb-2">
          <label class="form-label form-label-sm">MID</label>
          <input v-model="form.MID" type="text" class="form-control form-control-sm" maxlength="20" />
        </div>
        <div class="mb-2">
          <label class="form-label form-label-sm">Merchant Key</label>
          <input v-model="form.MerchantKey" type="text" class="form-control form-control-sm" maxlength="200" />
        </div>
        <div class="mb-2">
          <label class="form-label form-label-sm">Cancel Pwd</label>
          <input v-model="form.CancelPwd" type="text" class="form-control form-control-sm" maxlength="20" />
        </div>
        <div class="mb-2">
          <label class="form-label form-label-sm">은행명</label>
          <input v-model="form.BankName" type="text" class="form-control form-control-sm" maxlength="50" placeholder="예: 국민은행" />
        </div>
        <div class="mb-2">
          <label class="form-label form-label-sm">계좌번호</label>
          <input v-model="form.AccountNumber" type="text" class="form-control form-control-sm" maxlength="50" placeholder="예: 123-4567-8901" />
        </div>
        <div class="mb-2">
          <label class="form-label form-label-sm">접수 시작 날짜</label>
          <input v-model="form.AcceptStartDate" type="date" class="form-control form-control-sm" />
        </div>
        <div class="mb-2">
          <label class="form-label form-label-sm">접수 종료 날짜</label>
          <input v-model="form.AcceptEndDate" type="date" class="form-control form-control-sm" />
        </div>

        <div v-if="formError" class="alert alert-danger py-1 small">{{ formError }}</div>

        <div class="d-flex gap-2 justify-content-end">
          <button class="btn btn-secondary btn-sm" @click="formModal = false">취소</button>
          <button class="btn btn-primary btn-sm" :disabled="saving" @click="saveForm">
            {{ saving ? '저장 중...' : '저장' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 삭제 확인 모달 -->
    <div v-if="deleteModal" class="modal-backdrop-custom">
      <div class="modal-box" @click.stop>
        <h6 class="fw-bold mb-2">주차장 삭제</h6>
        <p class="mb-3">
          <strong>{{ deleteTarget?.AreaCode }}</strong> ({{ deleteTarget?.AreaName }}) 구역을 삭제합니다.<br/>
          <span class="text-danger small">이 작업은 되돌릴 수 없습니다.</span>
        </p>
        <div v-if="deleteError" class="alert alert-danger py-1 small">{{ deleteError }}</div>
        <div class="d-flex gap-2 justify-content-end">
          <button class="btn btn-secondary btn-sm" @click="deleteModal = false">취소</button>
          <button class="btn btn-danger btn-sm" :disabled="saving" @click="doDelete">
            {{ saving ? '삭제 중...' : '삭제' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 주차장 정보 모달 -->
    <div v-if="areaDetailModal" class="modal-backdrop-custom">
      <div class="modal-box" style="max-width: 900px; max-height: 90vh; overflow-y: auto;" @click.stop>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="fw-bold mb-0">주차장 정보 관리 - {{ areaDetailData?.AreaName }}</h6>
          <button class="btn-close" @click="areaDetailModal = false"></button>
        </div>

        <div v-if="areaDetailLoading" class="text-center text-muted py-4">불러오는 중...</div>

        <template v-else>
          <!-- 제목 입력 -->
          <div class="mb-3">
            <label class="form-label fw-bold">제목 (Title)</label>
            <input 
              v-model="areaDetailForm.Title" 
              type="text" 
              class="form-control" 
              maxlength="200"
              placeholder="주차장 정보 제목을 입력하세요"
            />
            <small class="text-muted">{{ areaDetailForm.Title.length }} / 200</small>
          </div>

          <!-- 내용 입력 -->
          <div class="mb-3">
            <label class="form-label fw-bold">내용 (Content)</label>
            <textarea 
              v-model="areaDetailForm.Content" 
              class="form-control" 
              rows="6"
              placeholder="주차장 상세정보를 입력하세요"
              style="resize: none;"
            ></textarea>
            <small class="text-muted">자유롭게 입력 가능</small>
          </div>

          <!-- 이미지 업로드 -->
          <div class="mb-3">
            <label class="form-label fw-bold">이미지</label>
            
            <!-- 드래그앤드롭 영역 -->
            <div 
              @drop.prevent="handleImageDrop"
              @dragover.prevent
              class="border-2 border-dashed rounded p-4 text-center"
              style="background-color: #f8f9fa; cursor: pointer; border-color: #dee2e6;"
            >
              <div class="text-muted mb-2">
                <i class="bi bi-cloud-arrow-up"></i> 이미지를 드래그앤드롭하거나 클릭하여 업로드
              </div>
              <input 
                type="file" 
                multiple 
                accept="image/*"
                @change="handleImageSelect"
                style="display: none;"
                ref="imageInput"
              />
              <button 
                type="button"
                class="btn btn-sm btn-outline-primary"
                @click="$refs.imageInput.click()"
              >
                파일 선택
              </button>
              <small class="d-block mt-2 text-muted">여러 이미지를 선택할 수 있습니다</small>
            </div>
          </div>

          <!-- 이미지 미리보기 -->
          <div v-if="areaImages.length > 0" class="mb-3">
            <label class="form-label fw-bold">업로드된 이미지 ({{ areaImages.length }}장)</label>
            <div class="row g-2">
              <div v-for="(img, idx) in areaImages" :key="idx" class="col-6 col-sm-4 col-md-3">
                <div class="card">
                  <div class="position-relative">
                    <img 
                      :src="img.preview || (img.ImagePath ? `${apiBase}/${img.ImagePath}` : '')" 
                      class="card-img-top" 
                      alt="Preview"
                      style="height: 150px; object-fit: cover;"
                    />
                    <button 
                      v-if="!img.ImageSeq"
                      type="button"
                      class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                      @click="removeImagePreview(idx)"
                      title="삭제"
                    >
                      ✕
                    </button>
                    <button 
                      v-else
                      type="button"
                      class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                      @click="deleteImage(img.ImageSeq)"
                      title="삭제"
                    >
                      ✕
                    </button>
                  </div>
                  <div class="card-footer py-1 px-2 small text-truncate">
                    {{ img.ImageName }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="areaDetailError" class="alert alert-danger py-2">{{ areaDetailError }}</div>

          <!-- 버튼 -->
          <div class="d-flex gap-2 justify-content-end">
            <button class="btn btn-secondary btn-sm" @click="areaDetailModal = false">취소</button>
            <button 
              class="btn btn-primary btn-sm" 
              :disabled="areaDetailSaving"
              @click="saveAreaDetail"
            >
              {{ areaDetailSaving ? '저장 중...' : '저장' }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ApiKeyModal from '../../components/ApiKeyModal.vue'

const emptyForm = () => ({ AreaSeq: null, AreaCode: '', AreaName: '', MID: '', MerchantKey: '', CancelPwd: '', BankName: '', AccountNumber: '', AcceptStartDate: '', AcceptEndDate: '' })

export default {
  name: 'AdminParkingAreaView',
  components: {
    ApiKeyModal
  },
  data() {
    return {
      areas: [],
      loading: false,
      loadError: null,
      formModal: false,
      isEdit: false,
      form: emptyForm(),
      formError: null,
      deleteModal: false,
      deleteTarget: null,
      deleteError: null,
      saving: false
      ,
      // fees
      feeModal: false,
      feeArea: null,
      fees: [],
      feeLoading: false,
      feeError: null,
      feeForm: { FeeSeq: null, FeeName: '', Price: null },
      feeFormError: null,
      feeFormEdit: false,
      feeSaving: false
      ,
      // api key
      apiModal: false,
      apiArea: null,
      // groups
      groupModal: false,
      groupArea: null,
      groups: [],
      groupLoading: false,
      groupError: null,
      groupForm: { GroupSeq: null, GroupName: '', QuotaCount: null },
      groupFormError: null,
      groupFormEdit: false,
      groupSaving: false,
      // 주차장 정보
      areaDetailModal: false,
      areaDetailData: null,
      areaDetailForm: { Title: '', Content: '' },
      areaDetailLoading: false,
      areaDetailSaving: false,
      areaDetailError: null,
      areaImages: [],
      uploadingImages: false,
      serverTime: '-'
    }
  },
  computed: {
    apiBase() {
      return process.env.VUE_APP_API_BASE || ''
    }
  },
  mounted() {
    this.fetchServerTime()
    this.fetchAreas()
  },
  methods: {
    async fetchServerTime() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/server-time`)
        // 백엔드에서 이미 포맷팅된 문자열을 반환하므로 그대로 사용
        this.serverTime = res.data.serverTime
      } catch (e) {
        console.error('서버 시간 조회 실패:', e)
        this.serverTime = '조회 실패'
      }
    },
    formatDateTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    async fetchAreas() {
      this.loading = true
      this.loadError = null
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area`)
        this.areas = res.data.map(a => ({
          ...a,
          AcceptStartDate: a.AcceptStartDate ? new Date(a.AcceptStartDate).toISOString().slice(0, 10) : '',
          AcceptEndDate: a.AcceptEndDate ? new Date(a.AcceptEndDate).toISOString().slice(0, 10) : ''
        }))
      } catch {
        this.loadError = '주차장 목록을 불러오지 못했습니다.'
      } finally {
        this.loading = false
      }
    },
    openApiKey(area) {
      this.apiArea = area
      this.apiModal = true
    },
    openAdd() {
      this.isEdit = false
      this.form = emptyForm()
      this.formError = null
      this.formModal = true
    },
    openEdit(a) {
      this.isEdit = true
      this.form = { ...a }
      this.formError = null
      this.formModal = true
    },
    async saveForm() {
      const { AreaCode, AreaName } = this.form
      if (!AreaCode.trim() || !AreaName.trim()) {
        this.formError = '구역 코드와 구역명은 필수입니다.'
        return
      }
      this.saving = true
      this.formError = null
      try {
        const payload = {
          areaCode: AreaCode,
          areaName: AreaName,
          mid: this.form.MID?.trim() || null,
          merchantKey: this.form.MerchantKey?.trim() || null,
          cancelPwd: this.form.CancelPwd?.trim() || null,
          bankName: this.form.BankName?.trim() || null,
          accountNumber: this.form.AccountNumber?.trim() || null,
          acceptStartDate: this.form.AcceptStartDate || null,
          acceptEndDate: this.form.AcceptEndDate || null
        }
        if (this.isEdit) {
          await axios.put(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${this.form.AreaSeq}`, payload)
        } else {
          await axios.post(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area`, payload)
        }
        this.formModal = false
        await this.fetchAreas()
      } catch (e) {
        this.formError = e.response?.data?.message || '저장에 실패했습니다.'
      } finally {
        this.saving = false
      }
    },
    confirmDelete(a) {
      this.deleteTarget = a
      this.deleteError = null
      this.deleteModal = true
    },
    async doDelete() {
      this.saving = true
      this.deleteError = null
      try {
        await axios.delete(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${this.deleteTarget.AreaSeq}`)
        this.deleteModal = false
        await this.fetchAreas()
      } catch (e) {
        this.deleteError = e.response?.data?.message || '삭제에 실패했습니다.'
      } finally {
        this.saving = false
      }
    },
    // 요금제 관리
    async openFeeManage(area) {
      this.feeArea = area
      this.feeError = null
      this.feeModal = true
      await this.fetchFees(area.AreaCode)
    },
    async fetchFees(areaCode) {
      this.feeLoading = true
      this.fees = []
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/admin/parking-fee?areaCode=${encodeURIComponent(areaCode)}`)
        this.fees = res.data
      } catch (e) {
        this.feeError = '요금제 목록을 불러오지 못했습니다.'
      } finally {
        this.feeLoading = false
      }
    },
    openAddFee() {
      this.feeFormEdit = false
      this.feeForm = { FeeSeq: null, FeeName: '', Price: null }
      this.feeFormError = null
    },
    onApiModalClose() {
      this.apiModal = false
      this.apiArea = null
      this.fetchAreas()
    },
    openEditFee(f) {
      this.feeFormEdit = true
      this.feeForm = { FeeSeq: f.FeeSeq, FeeName: f.FeeName, Price: f.Price }
      this.feeFormError = null
    },
    async saveFee() {
      const { FeeSeq, FeeName, Price } = this.feeForm
      if (!FeeName || Price == null) {
        this.feeFormError = '요금명과 가격은 필수입니다.'
        return
      }
      this.feeSaving = true
      try {
        if (this.feeFormEdit) {
          await axios.put(`${process.env.VUE_APP_API_BASE}/api/admin/parking-fee/${FeeSeq}`, { feeName: FeeName, price: Price })
        } else {
          await axios.post(`${process.env.VUE_APP_API_BASE}/api/admin/parking-fee`, { areaCode: this.feeArea.AreaCode, feeName: FeeName, price: Price })
        }
        await this.fetchFees(this.feeArea.AreaCode)
        this.feeForm = { FeeSeq: null, FeeName: '', Price: null }
        this.feeFormEdit = false
      } catch (e) {
        this.feeFormError = e.response?.data?.message || '저장에 실패했습니다.'
      } finally {
        this.feeSaving = false
      }
    },
    confirmDeleteFee(f) {
      if (!confirm(`요금제 "${f.FeeName}"을(를) 삭제하시겠습니까?`)) return
      this.doDeleteFee(f)
    },
    async doDeleteFee(f) {
      try {
        await axios.delete(`${process.env.VUE_APP_API_BASE}/api/admin/parking-fee/${f.FeeSeq}`)
        await this.fetchFees(this.feeArea.AreaCode)
      } catch (e) {
        alert(e.response?.data?.message || '삭제에 실패했습니다.')
      }
    },
    // 그룹 관리
    async openGroupManage(area) {
      this.groupArea = area
      this.groupError = null
      this.groupModal = true
      await this.fetchGroups(area.AreaSeq)
    },
    async fetchGroups(areaSeq) {
      this.groupLoading = true
      this.groups = []
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/admin/waiting-group-quota?areaSeq=${areaSeq}`)
        this.groups = res.data
      } catch (e) {
        this.groupError = '그룹 목록을 불러오지 못했습니다.'
      } finally {
        this.groupLoading = false
      }
    },
    openAddGroup() {
      this.groupFormEdit = false
      this.groupForm = { GroupSeq: null, GroupName: '', QuotaCount: null }
      this.groupFormError = null
    },
    openEditGroup(g) {
      this.groupFormEdit = true
      this.groupForm = { GroupSeq: g.GroupSeq, GroupName: g.GroupName, QuotaCount: g.QuotaCount }
      this.groupFormError = null
    },
    async saveGroup() {
      const { GroupSeq, GroupName, QuotaCount } = this.groupForm
      if (!GroupName || QuotaCount == null) {
        this.groupFormError = '그룹명과 할당수량은 필수입니다.'
        return
      }
      this.groupSaving = true
      try {
        if (this.groupFormEdit) {
          await axios.put(`${process.env.VUE_APP_API_BASE}/api/admin/waiting-group-quota/${GroupSeq}`, { groupName: GroupName, quotaCount: QuotaCount })
        } else {
          await axios.post(`${process.env.VUE_APP_API_BASE}/api/admin/waiting-group-quota`, { areaSeq: this.groupArea.AreaSeq, groupName: GroupName, quotaCount: QuotaCount })
        }
        await this.fetchGroups(this.groupArea.AreaSeq)
        this.groupForm = { GroupSeq: null, GroupName: '', QuotaCount: null }
        this.groupFormEdit = false
      } catch (e) {
        this.groupFormError = e.response?.data?.message || '저장에 실패했습니다.'
      } finally {
        this.groupSaving = false
      }
    },
    confirmDeleteGroup(g) {
      if (!confirm(`그룹 "${g.GroupName}"을(를) 삭제하시겠습니까?`)) return
      this.doDeleteGroup(g)
    },
    async doDeleteGroup(g) {
      try {
        await axios.delete(`${process.env.VUE_APP_API_BASE}/api/admin/waiting-group-quota/${g.GroupSeq}`)
        await this.fetchGroups(this.groupArea.AreaSeq)
      } catch (e) {
        alert(e.response?.data?.message || '삭제에 실패했습니다.')
      }
    },
    // 주차장 정보
    async openAreaDetail(area) {
      this.areaDetailData = area
      this.areaDetailModal = true
      this.areaDetailLoading = true
      this.areaDetailError = null
      this.areaDetailForm = { Title: '', Content: '' }
      this.areaImages = []
      
      try {
        // 기존 정보 조회
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${area.AreaSeq}/detail`)
        if (res.data) {
          this.areaDetailForm = {
            Title: res.data.Title || area.AreaName,
            Content: res.data.Content || ''
          }
        } else {
          this.areaDetailForm = {
            Title: area.AreaName,
            Content: ''
          }
        }
        
        // 이미지 조회
        const imgRes = await axios.get(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${area.AreaSeq}/images`)
        this.areaImages = imgRes.data.images || []
      } catch (e) {
        this.areaDetailError = e.response?.data?.message || '정보를 불러오지 못했습니다.'
      } finally {
        this.areaDetailLoading = false
      }
    },
    handleImageSelect(event) {
      const files = Array.from(event.target.files)
      this.addImagePreview(files)
    },
    handleImageDrop(event) {
      const files = Array.from(event.dataTransfer.files).filter(f => f.type.startsWith('image/'))
      this.addImagePreview(files)
    },
    addImagePreview(files) {
      files.forEach(file => {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.areaImages.push({
            file: file,
            preview: e.target.result,
            ImageName: file.name
          })
        }
        reader.readAsDataURL(file)
      })
    },
    removeImagePreview(idx) {
      this.areaImages.splice(idx, 1)
    },
    async deleteImage(imageSeq) {
      if (!confirm('이미지를 삭제하시겠습니까?')) return
      try {
        await axios.delete(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/image/${imageSeq}`)
        this.areaImages = this.areaImages.filter(img => img.ImageSeq !== imageSeq)
      } catch (e) {
        alert(e.response?.data?.message || '이미지 삭제에 실패했습니다.')
      }
    },
    async saveAreaDetail() {
      const title = (this.areaDetailForm.Title || '').trim() || this.areaDetailData?.AreaName || ''
      const content = (this.areaDetailForm.Content || '').trim()

      if (!title || !content) {
        this.areaDetailError = '제목과 내용은 필수입니다.'
        return
      }

      this.areaDetailForm.Title = title
      this.areaDetailSaving = true
      this.areaDetailError = null
      
      try {
        // 1. 제목과 내용 저장
        await axios.post(`${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${this.areaDetailData.AreaSeq}/detail`, {
          title: title,
          content: content
        })
        
        // 2. 새로운 이미지 업로드 (file 속성이 있는 항목들)
        const newImages = this.areaImages.filter(img => img.file)
        if (newImages.length > 0) {
          const formData = new FormData()
          newImages.forEach(img => {
            formData.append('images', img.file)
          })
          
          await axios.post(
            `${process.env.VUE_APP_API_BASE}/api/admin/parking-area/${this.areaDetailData.AreaSeq}/upload-images`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
        }
        
        this.areaDetailModal = false
        alert('저장되었습니다.')
      } catch (e) {
        this.areaDetailError = e.response?.data?.message || '저장에 실패했습니다.'
      } finally {
        this.areaDetailSaving = false
      }
    }
  }
}
</script>

<style scoped>
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-box {
  background: #fff;
  border-radius: 10px;
  padding: 1.5rem;
  width: 420px;
  max-width: 95vw;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}
</style>
